module.exports = __webpack_public_path__ + "img/D201705_4.9c4d6bfd.jpg";